import { getCurrentInstance } from 'vue-demi';

var en = {
	services: {
		storybook: {
			label: "Storybook"
		},
		softphone: {
			label: "Soft Phone"
		},
		aiassist: {
			label: "AI Assist"
		},
		problem_helper: {
			label: "Report a problem"
		}
	},
	components: {
		emojipicker: {
			label: "Emoji Picker"
		}
	},
	notifications: {
		Notifications: "Notifications",
		"Trail events": "Trail events",
		"Mark all as read": "Mark all as read",
		"No notifications yet": "No notifications yet",
		"There is no new notifications for you": "There is no new notifications for you."
	},
	serviceDropdown: {
		label: "Services",
		"No results": "No results",
		results: "results",
		"We couldn't find": "We couldn't find",
		"Please update your search criteria.": "Please update your search criteria."
	},
	idw: "IDW"
};
var DEFAULT_TRANSLATIONS = {
	en: en
};

function useI18n() {
  return {
    initializeI18n() {
      var _a;
      const i18n = (this === null || this === void 0 ? void 0 : this.$i18n) || ((_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy).$i18n;
      i18n.mergeLocaleMessage(i18n.locale, DEFAULT_TRANSLATIONS.en);
    },
    mergeLocaleMessages(messages) {
      var _a;
      const i18n = (this === null || this === void 0 ? void 0 : this.$i18n) || ((_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy).$i18n;
      for (const locale in messages) {
        i18n.mergeLocaleMessage(locale, messages[locale]);
      }
    },
    translate(str) {
      var _a;
      const i18n = (this === null || this === void 0 ? void 0 : this.$i18n) || ((_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy).$i18n;
      return i18n.t(str);
    }
  };
}

export { useI18n as u };
